import { Loader2, Inbox, AlertTriangle, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';

export function LoadingState({ label = 'Chargement...' }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-muted-foreground" data-testid="loading-state">
      <Loader2 className="h-8 w-8 animate-spin text-brand" />
      <p className="font-mono text-sm uppercase tracking-widest">{label}</p>
    </div>
  );
}

export function EmptyState({ icon: Icon = Inbox, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-border py-20 text-center" data-testid="empty-state">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-surface-card">
        <Icon className="h-7 w-7 text-brand" />
      </div>
      <div className="space-y-1">
        <h3 className="font-display text-xl font-semibold text-white">{title}</h3>
        {description && <p className="mx-auto max-w-md text-sm text-muted-foreground">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export function ErrorState({ message = 'Une erreur est survenue', onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-20 text-center" data-testid="error-state">
      <AlertTriangle className="h-9 w-9 text-destructive" />
      <p className="max-w-md text-sm text-muted-foreground">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="rounded-full bg-surface-card px-5 py-2 text-sm font-medium text-white hover:bg-surface-cardHover" data-testid="error-retry-button">
          Réessayer
        </button>
      )}
    </div>
  );
}

export function UnauthorizedState() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24 text-center" data-testid="unauthorized-state">
      <Lock className="h-9 w-9 text-brand" />
      <h3 className="font-display text-xl font-semibold text-white">Connexion requise</h3>
      <p className="max-w-md text-sm text-muted-foreground">Connecte-toi pour accéder à cette section de MyMusic IA.</p>
      <Link to="/login" className="rounded-full bg-brand px-6 py-2.5 text-sm font-semibold text-black btn-glow hover:bg-brand-hover" data-testid="unauthorized-login-button">
        Se connecter
      </Link>
    </div>
  );
}
